import Types from "./Types";

const INITIAL_STATE = {
  teachers: [],
  teacher: {},
  isLoading: false,
  count: "",
  teacherAdmin: {},
};

export default function superadminTeachers(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_SUPERADMIN_TEACHERS_SUCCESS: {
      return {
        ...state,
        teachers: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_SUPERADMIN_TEACHER_SUCCESS: {
      return {
        ...state,
        teacher: payload,
      };
    }

    case Types.EDIT_SUPERADMIN_TEACHER_SUCCESS: {
      let data = payload.data;
      const teachers = state.teachers;
      let idx = 0;
      teachers.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      teachers[idx] = data;
      return {
        ...state,
        teachers: teachers,
      };
    }

    // create
    case Types.CREATE_SUPERADMIN_TEACHER_SUCCESS: {
      const data = payload.data.data;
      let newArray = state.teachers.slice();
      let index = state.teachers.length + 1;
      newArray.splice(index, 0, data);
      return {
        ...state,
        teachers: newArray,
        count: state.count + 1,
      };
    }
    case Types.ADD_SUPERADMIN_TEACHERS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.DELETE_SUPERADMIN_TEACHER_SUCCESS: {
      const newteachers = state.teachers.filter((item) => item.id !== payload);
      return {
        ...state,
        teachers: newteachers,
        count: state.count - 1,
      };
    }
    case Types.ADD_TEACHER_ADMIN_SUCCESS: {
      return {
        ...state,
        teacherAdmin: payload,
      };
    }
    default: {
      return state;
    }
  }
}
